import { useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SPACING } from '../theme';

/**
 * Cap for dynamically-sized bottom sheets (`maxDynamicContentSize`). Keeps a
 * tall sheet below the status bar / notch with a little breathing room, which
 * is also what lets the sheet's BottomSheetScrollView actually scroll once
 * content exceeds the cap — an unbounded dynamic sheet fills the window and
 * its inner scrollable never engages (notably on web).
 */
export function useMaxSheetHeight(): number {
  const { height } = useWindowDimensions();
  const insets = useSafeAreaInsets();
  return Math.round(height - insets.top - SPACING.xl);
}
